'use client'
import BlogPosts from "@/app/[slug]/components/BlogPosts"
import ConteudoAba from "@/app/[slug]/components/ConteudoAba"
import ConteudoAccordion1 from "@/app/[slug]/components/ConteudoAccordion1"
import ConteudoAccordion2 from "@/app/[slug]/components/ConteudoAccordion2"
import ConteudoBrasalNumeros from "@/app/[slug]/components/ConteudoBrasalNumeros"
import ConteudoIcone1 from "@/app/[slug]/components/ConteudoIcone1"
import ConteudoIcone2 from "@/app/[slug]/components/ConteudoIcone2"
import ConteudoIcone3 from "@/app/[slug]/components/ConteudoIcone3"
import ConteudoImg1 from "@/app/[slug]/components/ConteudoImg1"
import ConteudoImg2 from "@/app/[slug]/components/ConteudoImg2"
import ConteudoImg3 from "@/app/[slug]/components/ConteudoImg3"
import ConteudoImgSlider from "@/app/[slug]/components/ConteudoImgSlider"
import ConteudoTexto1 from "@/app/[slug]/components/ConteudoTexto1"
import ConteudoVid1 from "@/app/[slug]/components/ConteudoVid1"
import ConteudoVidSlider from "@/app/[slug]/components/ConteudoVidSlider"
import HeadingText1 from "@/app/[slug]/components/HeadingText1"
import SliderPortfolio1 from "@/app/[slug]/components/SliderPortfolio1"
import SliderPortfolio2 from "@/app/[slug]/components/SliderPortfolio2"
import HeaderComponent from "@/app/[slug]/components/header/page"
import BannerComponent from "@/components/footer/banner"
import FooterComponent from "@/components/footer/footer"
import { Box, Heading, Show } from "@chakra-ui/react"
import Head from "next/head"
import ConteudoTextoBlog from "@/app/noticias/components/ConteudoTextoBlog"
import BlogHeader from "@/app/noticias/components/BlogHeader"
import {FacebookShareButton, FacebookIcon, TwitterShareButton, TwitterIcon, WhatsappShareButton, WhatsappIcon,LinkedinShareButton,LinkedinIcon,EmailShareButton,EmailIcon,} from 'next-share'
import { useEffect, useState } from "react"
import Consent from "@/components/Consent"


const DinamicNews = (props: any) => {
  const { dataNews, cabecalho, footer, config, menuRodape, categories } = props
  //dataNews?.attributes?.Descricao = dataNews?.attributes?.Conteudo

  const [currentUrl, setCurrentUrl] = useState('')

  useEffect(() => {
    setCurrentUrl(window.location.href)
  },[])

  

  return (
    <>
      <Head>
        <title>{dataNews?.attributes?.Titulo}</title>
      </Head>
      <HeaderComponent 
        cabecalho={cabecalho} 
        localizations={dataNews?.attributes?.localizations} 
        blogCategories={dataNews?.attributes?.BlogCategorias}
        />
      <BlogHeader data={{ ...dataNews?.attributes, Alinhamento: 'Esquerda' }} />
      <Box mt={'80px'}>
        <ConteudoTextoBlog data={{ ...dataNews?.attributes, Alinhamento: 'Esquerda' }} categories={categories} >
          {dataNews?.attributes?.ConteudoExtra.map((component: any, index: number) => {
            switch (component.__component) {
              case 'page.conteudo1':
                return <ConteudoImg1 key={'page_conteudo-img1_' + index} data={component} />
              case 'page.conteudo-img2':
                return <ConteudoImg2 key={'page_conteudo-img2_' + index} data={component} />
              case 'page.conteudo-img3':
                return <ConteudoImg3 key={'page_conteudo-img3_' + index} data={component} />
              case 'page.conteudo-img-slider':
                return <ConteudoImgSlider key={'page_conteudo-img-slider_' + index} data={component} />
              case 'SliderPortifolio1':
                return <SliderPortfolio1 key={'page_slide-port1_' + index} data={component} />
              case 'SliderPortifolio2':
                return <SliderPortfolio2 key={'page_slide=port2_' + index} data={component} />
              case 'page.conteudo-vid1':
                return <ConteudoVid1 key={'page_conteudo_video_' + index} data={component} />
              case 'page.conteudo-vid-slider':
                return <ConteudoVidSlider key={'page_conteudo_video_slider_' + index} data={component} />
              case 'page.conteudo-icone1':
                return <ConteudoIcone1 key={'page_conteudo-icon1_' + index} data={component} />
              case 'page.conteudo-icone2':
                return <ConteudoIcone2 key={'page_conteudo_icon2_' + index} data={component} />
              case 'page.conteudo-icone3':
                return <ConteudoIcone3 key={'page_conteudo_icon3_' + index} data={component} />
              case 'page.conteudo-brasal-numeros':
                return <ConteudoBrasalNumeros key={'page_conteudo_brasal_numeros_' + index} data={component} />
              case 'page.heading-texto1':
                return <HeadingText1 key={'page_heading_texto1_' + index} data={component} />
              case 'page.conteudo-texto1':
                return <ConteudoTexto1 key={'page_conteudo_texto1_' + index} data={component} />
              case 'page.conteudo-historia-timeline':
                return <ConteudoAccordion1 key={'page_conteudo_hist_timeline1_' + index} data={component} />
              case 'page.conteudo-accaordion2':
                return <ConteudoAccordion1 key={'page_conteudo_accordion1_' + index} data={component} />
              case 'page.conteudo-accaordion1':
                return <ConteudoAccordion2 key={'page_conteudo_accordion2_' + index} data={component} />
              case 'page.blog-posts':
                return <BlogPosts key={'page_blog_posts_' + index} data={component} news={dataNews} />
              case 'page.aba-conteudo1':
                return <ConteudoAba key={'page_aba_conteudo_' + index} data={component} />
              default:
                return <Box key={'nao-encontrado-' + index}>Componente não encontrado: {component.__component}</Box>
            }
          })}
          <Box className="social-share" display={'flex'} mb={10} fontSize={14} justifyContent={'end'} alignItems={'center'} px={4}>
          Compartilhe em:&nbsp;&nbsp;
            <FacebookShareButton url={currentUrl} quote={'Confira mais essa novidade no Portal Brasal.'} hashtag={'#portalbrasal'}>
              <FacebookIcon size={32} round />
            </FacebookShareButton>
            <TwitterShareButton url={currentUrl} title={'Confira mais essa novidade no Portal Brasal.'}>
              <TwitterIcon size={32} round />
            </TwitterShareButton>
            <WhatsappShareButton url={currentUrl} title={'Confira mais essa novidade no Portal Brasal.'} separator=":: ">
              <WhatsappIcon size={32} round />
            </WhatsappShareButton>
            <LinkedinShareButton url={currentUrl}>
              <LinkedinIcon size={32} round />
            </LinkedinShareButton>
            <EmailShareButton url={currentUrl} subject={'Confira mais essa novidade no Portal Brasal.'} body="body">
              <EmailIcon size={32} round />
            </EmailShareButton>
          </Box>
        </ConteudoTextoBlog>



      </Box>

      <BannerComponent data={footer.NuvemPalavras} />
      <FooterComponent data={footer} config={config?.data?.attributes} menu={menuRodape} />
      <Consent />
    </>
  )
}
export default DinamicNews
